import { render, staticRenderFns } from "./EditSectionsContent.vue?vue&type=template&id=b00f54da"
import script from "./EditSectionsContent.vue?vue&type=script&lang=js"
export * from "./EditSectionsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports